import Vue from "vue";
import Router from "vue-router";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path:'/',
            redirect: '/login'
        },
        {
            path: '/',
            component: resolve => require(['../components/nav/framework.vue'], resolve),
            children: [
                {
                    path: '/account_overview',
                    component: resolve => require(['../components/pages/AccountOverview.vue'], resolve),
                },
                {
                    path: '/login_overview',
                    component: resolve => require(['../components/pages/LoginOverview.vue'], resolve),
                },
                {
                    path: '/sensor_model_overview',
                    component: resolve => require(['../components/pages/SensorModelOverview.vue'], resolve),
                },
                {
                    path: '/params_overview',
                    component: resolve => require(['../components/pages/ParamsOverview.vue'], resolve),
                },
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/pages/Login.vue'], resolve),
        },

    ]
})